import squares from '../store/Squares';

export default {
    "name": "Blog",
    "title": "Blog",
    "links": ['Message', 'Home'],
    "images": {},
    "squares": squares,
    "background": "backgroundBlog",
    "text": [],
};
